import RodinnyStavSelect from './RodinnyStavSelect';

export default RodinnyStavSelect;
